import { Box, Typography } from "@mui/material";

const MaintenancePage = () => {
  return (
    <Box
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      sx={{ backgroundColor: "#F5F7FA", px: 3 }}
    >
      <Box
        sx={{
          textAlign: "center",
          maxWidth: "500px",
          p: 5,
          borderRadius: "12px",
          backgroundColor: "#fff",
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
        }}
      >
        <i
          className="fa-solid fa-screwdriver-wrench"
          style={{ fontSize: "48px", color: "#455459", marginBottom: "20px" }}
        />
        <Typography
          sx={{
            fontSize: "28px",
            fontWeight: 600,
            color: "#22333B",
            mt: 2,
          }}
        >
          Coming Soon
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 400,
            color: "#455459",
            mt: 2,
            lineHeight: 1.6,
          }}
        >
          Our platform is currently undergoing maintenance. 
          We're working to improve your experience and will be back online soon.
        </Typography>
        {/* <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 400,
            color: "#838D90",
            mt: 3,
          }}
        >
          Thank you for your patience.
        </Typography> */}
      </Box>
    </Box>
  );
};

export default MaintenancePage;
